import { HelpFile } from '~core/model';

export const HelpFiles: HelpFile[] = [
  {
    downloadName: 'Search Navigation Guide.pdf',
    displayName: 'Navigation Guide',
    serverName: 'search-navigation-guide.pdf'
  }
];



// WEBPACK FOOTER //
// ./src/app/shared/utils/help-files.ts